import script from "./AddRecommendationPop.vue?vue&type=script&setup=true&lang=js"
export * from "./AddRecommendationPop.vue?vue&type=script&setup=true&lang=js"

import "./AddRecommendationPop.vue?vue&type=style&index=0&id=a04fda48&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-a04fda48"]])

export default __exports__